import React, { useState } from 'react';
import { TextField, Button, Box, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useAuth } from '../Auth';
import { useSnackbar } from '../context/SnackbarContext';
import api from '../api/axiosInstance';

export default function PasswordChangeForm({ onSuccess, onCancel, showCancel = true }) {
    const { user, setUser } = useAuth();
    const showSnackbar = useSnackbar();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleUpdate = async () => {
        if (newPassword !== confirmPassword) {
            return showSnackbar("Passwords do not match", "error");
        }

        try {
            // We use your existing PUT endpoint or the new forced endpoint
            // Note: I suggest using a dedicated /auth/change-password endpoint 
            // so you don't have to send the whole user object back and forth.
            const response = await api.put(`/staff/${user.id}`, {
                username: user.username,
                email: user.email,
                role: user.role,
                password: newPassword,
                requires_password_change: false // Reset the flag on success
            });

            if (response.status === 200) {
                showSnackbar('Password updated successfully');
                
                // Update local auth state so the 'forced' redirect clears
                const updatedUser = { ...user, requiresPasswordChange: false };
                localStorage.setItem('user', JSON.stringify(updatedUser));
                setUser(updatedUser);
                
                if (onSuccess) onSuccess();
            }
        } catch (err) {
            showSnackbar(err.response?.data?.message || 'Failed to update password', 'error');
        }
    };

    return (
        <Box sx={{ mt: 1 }}>
            <TextField
                label="New Password"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
            <TextField
                label="Confirm New Password"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Box sx={{ display: 'flex', gap: 2, mt: 3, justifyContent: 'flex-end' }}>
                {showCancel && <Button onClick={onCancel}>Cancel</Button>}
                <Button 
                    variant="contained" 
                    onClick={handleUpdate} 
                    disabled={!newPassword || newPassword !== confirmPassword}
                >
                    Update Password
                </Button>
            </Box>
        </Box>
    );
}